import React from "react";
import { Route, Routes } from "react-router-dom";
import DashboardScope1 from "../Pages/Scope1/Dashboard";
import PetroleumGasoline from "../Pages/Scope1/StationaryCombustion.js/PetroleumGasoline";
import NaturalGasEquipment from "../Pages/Scope1/StationaryCombustion.js/NaturalGas/NaturalGas";
import OnRoadVahicle from "../Pages/Scope1/MobileCombustion/OnRoadVahicles/Vehicle";
import MobileOffRoad from "../Pages/Scope1/MobileCombustion/OffRoad";
import FugitiveEmmissions from "../Pages/Scope1/FugitiveEmmissions";
import Refrigeration from "../Pages/Scope1/FugitiveEmission/RefrigerationAirConditioning/Refrigeration";
import Coal from "../Pages/Scope1/StationaryCombustion.js/Coal/Coal";
import Diesel from "../Pages/Scope1/StationaryCombustion.js/Diesel/Diesel";
import FuelOil from "../Pages/Scope1/StationaryCombustion.js/FuelOil/FuelOil";
import IndustrialProcess from "../Pages/Scope1/FugitiveEmission/IndustrialProcess/IndustrialProcess";
import LPG from "../Pages/Scope1/StationaryCombustion.js/LPG/LPG";
import Propane from "../Pages/Scope1/StationaryCombustion.js/Propane/Propane"
export const Scope1Routes = [
  { path: "/scope1/dashboard", element: <DashboardScope1 /> },
  { path: "scope1/stationary-combustion/coal", element: <Coal /> },
  { path: "scope1/stationary-combustion/diesel", element: <Diesel /> },
  { path: "scope1/stationary-combustion/lpg", element: <LPG /> },
  { path: "scope1/stationary-combustion/propane", element: <Propane /> },
  {
    path: "scope1/stationary-combustion/fuel-oil",
    element: <FuelOil />,
  },

  {
    path: "scope1/stationary-combustion/petroleumGasoline",
    element: <PetroleumGasoline />,
  },
  {
    path: "/scope1/Mobile-combustion/OffRoad",
    element: <MobileOffRoad />,
  },
  {
    path: "/scope1/FugitiveEmmissions/FireExtingulsher",
    element: <FugitiveEmmissions />,
  },
  { path: "/scope1/natural-gas", element: <NaturalGasEquipment /> },
  { path: "/scope1/onroad-vehicles", element: <OnRoadVahicle /> },
  {
    path: "scope1/fugitive-emission/refrigeration",
    element: <Refrigeration />,
  },
  {
    path: "/scope1/fugitive-emmissions/industrial-process",
    element: <IndustrialProcess />,
  },
];

export default Scope1Routes;
